<span>
  <button unity-button
    classes="icon-only icon-only-xlarge"
    (click)="fileInput.click()"
    [disabled]="this.model.inProgress || this.model.importComplete"
  >
    <svg
      *ngIf="!this.model.inProgress && !this.model.importComplete"
      [class]="'unity-icon unity-icon-folder-open'"
      documentDropZone
      (filesDroppedEmitter)="onFilesDropped($event)"
      [class.disabled]="this.model.inProgress || this.model.importComplete"
      ngbTooltip="Drag and Drop Files here, or Click to Select Files."
    >
      <use xlink:href="#unity-icon-folder-open"></use>
    </svg>
    <svg *ngIf="model.importComplete && model.failedCount == 0" class="unity-icon unity-icon-checkmark">
      <use xlink:href="#unity-icon-checkmark"></use>
    </svg>
    <svg style="fill: red" *ngIf="model.importComplete && model.failedCount > 0" class="unity-icon unity-icon-trash">
      <use xlink:href="#unity-icon-trash"></use>
    </svg>
    <span *ngIf="model.inProgress">
      <i class="fa fa-ep-in-progress fa-spin"></i>
      <span *ngIf="this.model.totalImportCount > 1" class="fa-stack-1x" style="font-weight: 600; font-size: 1rem">{{
        this.model.totalImportCount - this.model.importNumber
      }}</span>
    </span>
  </button>
</span>

<input
  #fileInput
  type="file"
  multiple="true"
  style="display: none"
  id="fileSelect"
  name="fileSelect"
  accept=".doc,.docx,.jpg,.jpeg,.pdf,.xls,.xlsm,.xlsx,.msg,.wav,.mp4,.txt,.bmp"
  (change)="filesSelected($event)"
/>
